module.exports = __webpack_public_path__ + "img/pattern.e86f855a.png";